import { Button, Dialog } from '@applyboard/crystal-ui'
import { CheckMarkOutlineIcon, PlusOutlineIcon } from '@applyboard/ui-icons'
import { PropsWithChildren } from 'react'
import { IDocumentDialog } from '../types'
import { getDocumentTypeLabel } from '../../../../utils'

export function DocumentDialog(props: PropsWithChildren<IDocumentDialog>) {
  if (props.document.isDocCompleted || props.document.requestStatus !== 'PENDING') {
    return (
      <Button
        size="lg"
        width="fill"
        emphasis="highlighted"
        intent="positive"
        disabled={!props.document.isDocCompleted && props.document.requestStatus === 'DISMISSED'}
        leadIcon={
          !props.document.isDocCompleted && props.document.requestStatus === 'DISMISSED'
            ? PlusOutlineIcon
            : CheckMarkOutlineIcon
        }
      >
        {getDocumentTypeLabel(props.document.documentType)}
      </Button>
    )
  }

  return (
    <Dialog open={props.open} onOpenChange={props.setOpen}>
      <Dialog.Trigger>
        <Button
          size="lg"
          width="fill"
          emphasis="highlighted"
          intent="primary"
          leadIcon={PlusOutlineIcon}
        >
          {getDocumentTypeLabel(props.document.documentType)}
        </Button>
      </Dialog.Trigger>
      <Dialog.Heading>{props.heading}</Dialog.Heading>
      <Dialog.Content>{props.children}</Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill">Cancel</Dialog.CloseButton>
        <Button
          form={props.form}
          type="submit"
          width="fill"
          intent="primary"
          loading={props.loading}
        >
          Save and submit
        </Button>
      </Dialog.Actions>
    </Dialog>
  )
}
